module.exports = __webpack_public_path__ + "assets/633aeda0bddec8e8536ae6f9384cee97.jpg";